// import { useEffect, useState } from "react";
// import PropTypes from "prop-types";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import { API_URL } from "config";
// import { useAuth } from "AuthContext";
// import { useMemo } from "react";

// import Card from "@mui/material/Card";
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import SoftButton from "components/SoftButton";
// import FormField from "layouts/pages/account/components/FormField";
// import SoftSnackbar from "components/SoftSnackbar";

// function ChangeUserPassword({ value = {}, onChange }) {

//   /* ================= PERMISSIONS ================= */
//   const { permissions: ctxPerms = [] } = useAuth();

//   const storedPerms = useMemo(() => {
//     try {
//       return JSON.parse(localStorage.getItem("permissions") || "[]");
//     } catch {
//       return [];
//     }
//   }, []);

//   const permSet = useMemo(() => {
//     const perms = ctxPerms.length ? ctxPerms : storedPerms;
//     return new Set(perms.map(p => (typeof p === "string" ? p : p.name)));
//   }, [ctxPerms, storedPerms]);

//   const canSection = permSet.has("UserProfile.ChangePassword");
//   const canView = (key) =>
//     permSet.has(`UserProfile.ChangePassword.${key}`);


//   const { id } = useParams();
//   const [formData, setFormData] = useState({
//     current_password: "",
//     new_password: "",
//     new_password_confirmation: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     color: "success",
//   });

//   useEffect(() => {
//     if (value) {
//       setFormData((prev) => ({
//         ...prev,
//         current_password: value.current_password || "",
//         new_password: value.new_password || "",
//         new_password_confirmation: value.new_password_confirmation || "",
//       }));
//     }
//   }, [value]);

//   const handleChange = (field) => (e) => {
//     const updated = { ...formData, [field]: e.target.value };
//     setFormData(updated);
//     onChange?.(updated);

//     if (errors[field]) {
//       setErrors((prev) => ({ ...prev, [field]: "" }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.current_password) {
//       newErrors.current_password = "Current password is required";
//     }

//     if (!formData.new_password) {
//       newErrors.new_password = "New password is required";
//     } else if (formData.new_password.length < 6) {
//       newErrors.new_password = "Password must be at least 6 characters";
//     }

//     if (formData.new_password !== formData.new_password_confirmation) {
//       newErrors.new_password_confirmation = "Passwords do not match";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       const response = await axios.put(
//         `${API_URL}/users/change-password/${id}`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//           },
//         }
//       );

//       setSnackbar({
//         open: true,
//         message: response.data.message || "Password updated successfully!",
//         color: "success",
//       });

//       setFormData({
//         current_password: "",
//         new_password: "",
//         new_password_confirmation: "",
//       });
//     } catch (error) {
//       console.error("Password change error:", error);

//       if (error.response?.data?.errors) {
//         setErrors(error.response.data.errors);
//         setSnackbar({
//           open: true,
//           message: "Please fix the errors in the form",
//           color: "error",
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           message: error.response?.data?.message || "Failed to update password",
//           color: "error",
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const passwordRequirements = [
//     "One special character",
//     "Min 6 characters",
//     "One number (2 are recommended)",
//     "Change it often",
//   ];

//   if (!canSection) {
//     return null;
//   }

//   return (
//     <>
//       <Card id="change-user-password" className="p-4">
//         {canView("CurrentPassword") && (
//           <>
//             <SoftTypography variant="h4" mb={3}>
//               Change Password
//             </SoftTypography>

//             <div className="row mb-3">
//               <div className="col-12">
//                 <FormField
//                   label="Current Password"
//                   placeholder="Current Password"
//                   value={formData.current_password}
//                   onChange={handleChange("current_password")}
//                   inputProps={{ type: "password", autoComplete: "off" }}
//                   error={!!errors.current_password}
//                   helperText={errors.current_password}
//                 />
//               </div>
//             </div>
//           </>
//         )}

//         <div className="row mb-3">
//           <div className="col-12">
//             {canView("NewPassword") && (
//               <FormField
//                 label="New Password"
//                 placeholder="New Password"
//                 value={formData.new_password}
//                 onChange={handleChange("new_password")}
//                 inputProps={{ type: "password", autoComplete: "off" }}
//                 error={!!errors.new_password}
//                 helperText={errors.new_password}
//               />
//             )}
//           </div>
//         </div>

//         <div className="row mb-4">
//           <div className="col-12">
//             {canView("ConfirmNewPassword") && (
//               <FormField
//                 label="Confirm New Password"
//                 placeholder="Confirm Password"
//                 value={formData.new_password_confirmation}
//                 onChange={handleChange("new_password_confirmation")}
//                 inputProps={{ type: "password", autoComplete: "off" }}
//                 error={!!errors.new_password_confirmation}
//                 helperText={errors.new_password_confirmation}
//               />
//             )}
//           </div>
//         </div>

//         {canView("Requirements") && (
//           <>
//             <SoftTypography variant="h5" mb={1}>
//               Password Requirements
//             </SoftTypography>
//             <SoftTypography variant="body2" mb={2}>
//               Please follow this guide for a strong password:
//             </SoftTypography>

//             <ul className="mb-4 ps-4">
//               {passwordRequirements.map((item, idx) => (
//                 <li key={`pw-req-${idx}`}>
//                   <SoftTypography variant="button" color="text">
//                     {item}
//                   </SoftTypography>
//                 </li>
//               ))}
//             </ul>
//           </>
//         )}

//         <div className="d-flex justify-content-end">
//           {canView("Save") && (
//             <SoftButton
//               variant="gradient"
//               color="dark"
//               size="small"
//               onClick={handleSubmit}
//               disabled={loading}
//             >
//               {loading ? "Saving..." : "Save Password"}
//             </SoftButton>
//           )}
//         </div>
//       </Card>

//       <SoftSnackbar
//         color={snackbar.color}
//         icon="notifications"
//         title="Notification"
//         content={snackbar.message}
//         open={snackbar.open}
//         close={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//         time={3000}
//       />
//     </>
//   );
// }

// ChangeUserPassword.propTypes = {
//   value: PropTypes.object,
//   onChange: PropTypes.func,
// };

// export default ChangeUserPassword;


import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URL } from "config";
import { useAuth } from "AuthContext";
import { useMemo } from "react";

import Card from "@mui/material/Card";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import FormField from "layouts/pages/account/components/FormField";
import SoftSnackbar from "components/SoftSnackbar";

// नया Dialog component import करें
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

function ChangeUserPassword({ value = {}, onChange }) {

  /* ================= PERMISSIONS ================= */
  const { permissions: ctxPerms = [] } = useAuth();

  const storedPerms = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("permissions") || "[]");
    } catch {
      return [];
    }
  }, []);

  const permSet = useMemo(() => {
    const perms = ctxPerms.length ? ctxPerms : storedPerms;
    return new Set(perms.map(p => (typeof p === "string" ? p : p.name)));
  }, [ctxPerms, storedPerms]);

  const canSection = permSet.has("UserProfile.ChangePassword");
  const canView = (key) =>
    permSet.has(`UserProfile.ChangePassword.${key}`);


  const { id } = useParams();
  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    new_password_confirmation: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    color: "success",
  });

  // नया state for confirmation dialog
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    title: "Confirm Password Change",
    message: "Are you sure you want to change the password? This action cannot be undone.",
  });

  useEffect(() => {
    if (value) {
      setFormData((prev) => ({
        ...prev,
        current_password: value.current_password || "",
        new_password: value.new_password || "",
        new_password_confirmation: value.new_password_confirmation || "",
      }));
    }
  }, [value]);

  const handleChange = (field) => (e) => {
    const updated = { ...formData, [field]: e.target.value };
    setFormData(updated);
    onChange?.(updated);

    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.current_password) {
      newErrors.current_password = "Current password is required";
    }

    if (!formData.new_password) {
      newErrors.new_password = "New password is required";
    } else if (formData.new_password.length < 6) {
      newErrors.new_password = "Password must be at least 6 characters";
    }

    if (formData.new_password !== formData.new_password_confirmation) {
      newErrors.new_password_confirmation = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // यह function dialog show करेगा
  const handleConfirmSubmit = () => {
    if (!validateForm()) return;

    setConfirmDialog({
      open: true,
      title: "Confirm Password Change",
      message: "Are you sure you want to change the password? This action cannot be undone.",
    });
  };

  // यह actual submit करेगा
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await axios.put(
        `${API_URL}/users/change-password/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setSnackbar({
        open: true,
        message: response.data.message || "Password updated successfully!",
        color: "success",
      });

      setFormData({
        current_password: "",
        new_password: "",
        new_password_confirmation: "",
      });
    } catch (error) {
      console.error("Password change error:", error);

      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
        setSnackbar({
          open: true,
          message: "Please fix the errors in the form",
          color: "error",
        });
      } else {
        setSnackbar({
          open: true,
          message: error.response?.data?.message || "Failed to update password",
          color: "error",
        });
      }
    } finally {
      setLoading(false);
      setConfirmDialog(prev => ({ ...prev, open: false }));
    }
  };

  // Dialog close handler
  const handleCloseDialog = () => {
    setConfirmDialog(prev => ({ ...prev, open: false }));
  };

  const passwordRequirements = [
    "One special character",
    "Min 6 characters",
    "One number (2 are recommended)",
    "Change it often",
  ];

  if (!canSection) {
    return null;
  }

  return (
    <>
      <Card id="change-user-password" className="p-4">
        {canView("CurrentPassword") && (
          <>
            <SoftTypography variant="h5" mb={3}>
              Change Password
            </SoftTypography>

            <div className="row mb-3">
              <div className="col-12">
                <FormField
                  label="Current Password"
                  placeholder="Current Password"
                  value={formData.current_password}
                  onChange={handleChange("current_password")}
                  inputProps={{ type: "password", autoComplete: "off" }}
                  error={!!errors.current_password}
                  helperText={errors.current_password}
                />
              </div>
            </div>
          </>
        )}

        <div className="row mb-3">
          <div className="col-12">
            {canView("NewPassword") && (
              <FormField
                label="New Password"
                placeholder="New Password"
                value={formData.new_password}
                onChange={handleChange("new_password")}
                inputProps={{ type: "password", autoComplete: "off" }}
                error={!!errors.new_password}
                helperText={errors.new_password}
              />
            )}
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-12">
            {canView("ConfirmNewPassword") && (
              <FormField
                label="Confirm New Password"
                placeholder="Confirm Password"
                value={formData.new_password_confirmation}
                onChange={handleChange("new_password_confirmation")}
                inputProps={{ type: "password", autoComplete: "off" }}
                error={!!errors.new_password_confirmation}
                helperText={errors.new_password_confirmation}
              />
            )}
          </div>
        </div>

        {canView("Requirements") && (
          <>
            <SoftTypography variant="h5" mb={1}>
              Password Requirements
            </SoftTypography>
            <SoftTypography variant="body2" mb={2}>
              Please follow this guide for a strong password:
            </SoftTypography>

            <ul className="mb-4 ps-4">
              {passwordRequirements.map((item, idx) => (
                <li key={`pw-req-${idx}`}>
                  <SoftTypography variant="button" color="text">
                    {item}
                  </SoftTypography>
                </li>
              ))}
            </ul>
          </>
        )}

        <div className="d-flex justify-content-end">
          {canView("Save") && (
            <SoftButton
              variant="gradient"
              color="info"
              onClick={handleConfirmSubmit} // यहाँ change किया है
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Password"}
            </SoftButton>
          )}
        </div>
      </Card>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmDialog.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <SoftButton onClick={handleCloseDialog} color="secondary">
            Cancel
          </SoftButton>
          <SoftButton
            onClick={handleSubmit}
            color="primary"
            autoFocus
            disabled={loading}
          >
            {loading ? "Changing..." : "Confirm"}
          </SoftButton>
        </DialogActions>
      </Dialog>

      <SoftSnackbar
        color={snackbar.color}
        icon="notifications"
        title="Notification"
        content={snackbar.message}
        open={snackbar.open}
        close={() => setSnackbar((prev) => ({ ...prev, open: false }))}
        time={3000}
      />
    </>
  );
}

ChangeUserPassword.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
};

export default ChangeUserPassword;